import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { translate } from 'react-i18next';
import cx from 'classnames';

@translate(['dashboard-sidebar'], { wait: true })
@onClickOutside
export class WebastoTimer extends Component {
  handleClickOutside(e) {
    e.preventDefault();
    e.stopPropagation(e);
    this.props.onClickOutside(e);
  }
  render() {
    const { currentDevice, setWebastoOn, setSeconds, t } = this.props;

    return (
      <div className="control-button__drop-down aside__drop-down" style={{ top: 'calc(100% - 10px)', left: 15, right: 15, opacity: 1 }}>
        <div className="aside__drop-down__panel" style={{ borderBottom: 0 }}>
          <a
            onClick={e => setSeconds(e, true)}
            className={cx('minus quantity-btn', { disable: currentDevice.webastoPeriodInSeconds === 120 })}
          />
          <div className="box">
            <input className="duration-input" value={Math.round(currentDevice.webastoPeriodInSeconds / 60)} readOnly />
            <span className="duration-note">
              {t('dashboard-sidebar:min')}
            </span>
          </div>
          <div className="note">
            {t('dashboard-sidebar:preheating')}
          </div>
          <a
            onClick={e => setSeconds(e, false)}
            className={cx('plus quantity-btn', { disable: currentDevice.webastoPeriodInSeconds === 1800 })}
          />
        </div>
      </div>
    );
  }
}

WebastoTimer.WrappedComponent.propTypes = {
  t: PropTypes.func.isRequired,
};

WebastoTimer.propTypes = {
  currentDevice: PropTypes.shape({
    canWebasto: PropTypes.bool,
  }).isRequired,
  onClickOutside: PropTypes.func.isRequired,
  setWebastoOn: PropTypes.func.isRequired,
  setSeconds: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DeviceControl/Webasto/WebastoTimer.js